import { Controller, ControllerProps } from "react-hook-form";

import { AutocompleteChangeDetails, AutocompleteValue } from "@mui/material";

import { routeResourceTypes } from "@services/api";

import {
  ResourceAutocomplete,
  ResourceAutocompleteProps,
} from "./ResourceAutocomplete";

export const ControlledResourceAutocomplete = <
  TResourceName extends keyof routeResourceTypes,
  Multiple extends boolean = false,
  DisableClearble extends boolean = false,
>({
  name,
  control,
  rules,
  onChange,
  helperText,
  ...props
}: Pick<ControllerProps<any>, "control" | "rules" | "name"> &
  ResourceAutocompleteProps<
    TResourceName,
    routeResourceTypes[TResourceName],
    Multiple,
    DisableClearble,
    false
  >) => {
  type TValue = AutocompleteValue<
    routeResourceTypes[TResourceName],
    Multiple,
    DisableClearble,
    false
  >;
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref: _, ...field }, fieldState: { error } }) => (
        <ResourceAutocomplete
          {...field}
          {...(props as any)}
          error={!!error}
          helperText={error?.message || helperText}
          value={(field.value ?? (props.multiple ? [] : null)) as TValue}
          onChange={(
            e,
            value: TValue,
            reason,
            details?: AutocompleteChangeDetails<
              routeResourceTypes[TResourceName]
            >
          ) => {
            if (Array.isArray(value)) {
              field.onChange(value?.map((v) => (v.id ? v.id : v)));
            } else {
              field.onChange(value?.id ?? value);
            }
            onChange?.(e, value, reason, details);
          }}
        />
      )}
    />
  );
};
